export const DESKTOP_ICON_MENU_LABEL = 'Create Desktop Computer Icon';
export const DESKTOP_ICON_MODAL_TITLE = 'Create a desktop computer icon';
export const DESKTOP_ICON_MODAL_BODY =
  'This places a Mentology icon on your Windows or Mac desktop or taskbar so you can open it like an app on this computer.';
export const DESKTOP_ICON_INSTALL_BUTTON = 'Install on this computer';
export const DESKTOP_ICON_FALLBACK =
  'If no install window appears, on this computer open Chrome or Edge → the ⋮ menu → Cast, save and share → Install Mentology (or Create shortcut). Tick Open as window.';
export const PHONE_QR_MENU_LABEL = 'Phone QR code — use on mobile';
export const PHONE_QR_MODAL_TITLE = 'Use Mentology on your phone';
export const PHONE_QR_MODAL_BODY =
  'Scan this QR code with your phone if you want to use Mentology on mobile.';
